if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      /* Allow mouse-wheel scrolling inside the dropdown when Lenis is active */
      if (this.elements.panel) this.elements.panel.setAttribute('data-lenis-prevent', '');
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      // Restore scroll when panel closes
      document.body.classList.remove('localization-panel-open');
      if (window.__lenis) window.__lenis.start();
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      const isOpening = this.elements.button.getAttribute('aria-expanded') === 'false';
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', isOpening.toString());
      // Lock scroll when panel opens
      if (isOpening) {
        document.body.classList.add('localization-panel-open');
        if (window.__lenis) window.__lenis.stop();
      } else {
        document.body.classList.remove('localization-panel-open');
        if (window.__lenis) window.__lenis.start();
      }
    }

    closeSelector(event) {
      const isChild = this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
      if (!event.relatedTarget || !isChild) {
        this.hidePanel();
      }
    }
  });
}
